import { isSafari, isChrome, isFirefox } from './services'

export const useNavigatorType = () => {
  return {
    isSafari: isSafari(),
    isChrome: isChrome(),
    isFirefox: isFirefox()
  }
}
